module.exports = __webpack_public_path__ + "static/media/price.0aa43d4c.svg";